export default __webpack_public_path__ + "static/media/image 7.761c3379.svg";